import { useState } from "react";
import { rippleRings } from "@/mocks/editorial";

const ringSize = [400, 304, 214, 130];
const ringVarMap: Record<string, string> = {
  party: "primary",
  affiliate: "accent",
  industry: "secondary",
  public: "foreground",
};

export default function RippleSection() {
  const [active, setActive] = useState(0);
  const current = rippleRings[active];

  return (
    <section
      id="ripple"
      className="scroll-mt-24 overflow-hidden bg-background-100 py-12 md:py-20"
    >
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
          {/* 涟漪图 */}
          <div className="order-2 lg:order-1 lg:col-span-5">
            <div className="relative mx-auto aspect-square w-full max-w-[400px]">
              {rippleRings.map((ring, i) => {
                const varName = ringVarMap[ring.key];
                const isActive = i === active;
                const opacity = isActive ? 0.28 : 0.08 + 0.03 * i;
                return (
                  <button
                    key={ring.key}
                    type="button"
                    aria-label={`查看${ring.label}`}
                    onClick={() => setActive(i)}
                    style={{
                      width: ringSize[i],
                      height: ringSize[i],
                      backgroundColor: `oklch(var(--${varName}-500) / ${opacity})`,
                      borderColor: `oklch(var(--${varName}-500) / ${isActive ? 0.85 : 0.4})`,
                    }}
                    className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border transition-all duration-500 ${
                      isActive ? "border-[2px]" : "border"
                    }`}
                  >
                    {isActive && (
                      <span
                        style={{ color: `oklch(var(--${varName}-500))` }}
                        className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs font-medium shadow-sm"
                      >
                        {ring.label}
                      </span>
                    )}
                  </button>
                );
              })}
              <div className="pointer-events-none absolute left-1/2 top-1/2 grid h-14 w-14 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-primary-500 text-background-50 shadow">
                <i className="ri-flashlight-fill text-lg"></i>
              </div>
            </div>

            {/* 移动端图例 */}
            <div className="mt-6 flex flex-wrap justify-center gap-2 lg:hidden">
              {rippleRings.map((r, i) => (
                <button
                  key={r.key}
                  type="button"
                  onClick={() => setActive(i)}
                  className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                    i === active
                      ? "bg-foreground-950 text-background-50"
                      : "bg-background-50 text-foreground-700 border border-background-300"
                  }`}
                >
                  {r.label}
                </button>
              ))}
            </div>
          </div>

          {/* 详情区 */}
          <div className="order-1 lg:order-2 lg:col-span-7">
            <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wide text-secondary-800">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500"></span>
              波及面 · 涟漪分层模型
            </p>
            <h2 className="mt-4 font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-[2rem] md:leading-[1.3]">
              事件像涟漪，一圈圈荡开
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">
              同一场震荡，落在不同圈层身上，力度与含义完全不同。点击左侧（或下方）
              同心圆，逐层看看每个圈层分别承受了什么。
            </p>

            <div className="mt-8 rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7">
              <div className="flex items-center justify-between gap-3">
                <h3 className="font-heading text-xl font-semibold text-foreground-950">
                  {current.label}
                </h3>
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                  <i className="ri-group-line"></i>
                  {current.who}
                </span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                {current.body}
              </p>
              <p className="mt-5 flex items-start gap-2 rounded-xl bg-primary-50 px-4 py-3 text-sm text-primary-800">
                <i className="ri-information-line mt-0.5"></i>
                <span>
                  <b className="font-medium">这一层的关键：</b>
                  {current.impact}
                </span>
              </p>
            </div>

            {/* 桌面图例切换 */}
            <div className="mt-5 hidden gap-2 lg:flex">
              {rippleRings.map((r, i) => (
                <button
                  key={r.key}
                  type="button"
                  onClick={() => setActive(i)}
                  className={`flex-1 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                    i === active
                      ? "bg-foreground-950 text-background-50"
                      : "border border-background-300 bg-background-50 text-foreground-700 hover:bg-secondary-100"
                  }`}
                >
                  {r.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}